<template>
  <div class="side_content">
    <div
      class="side_item"
      v-for="(tab, index) in tabs"
      :key="index"
      @click="activeTab(index)"
      :class="{ active: isSelected(index) }"
    >
      <img
        :src="
          isSelected(index)
            ? `${require(`../assets/hs/${tab.actBg}.png`)}`
            : `${require(`../assets/hs/${tab.bg}.png`)}`
        "
        alt=""
      />
      <div class="tab_title">
        <div class="title_icon">
          <img :src="`${require(`../assets/hs/bottom_icon${index + 1}.png`)}`" alt="" />
        </div>
        <div class="title_name">{{ tab.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBottom',
  data() {
    return {
      tabs: [
        {
          name: '电站总览',
          bg: 'tab_bottom_left',
          actBg: 'tab_bottom_left_active',
          isActive: false,
          viewCode: 'dz',
          changeView: true,
        },
        {
          name: '故障诊断',
          bg: 'tab_bottom',
          actBg: 'tab_bottom_active',
          isActive: false,
          viewCode: 'JK005',
          changeView: false,
        },
        {
          name: '智能巡检',
          bg: 'tab_bottom',
          actBg: 'tab_bottom_active',
          isActive: false,
          viewCode: 'JK007',
          changeView: true,
        },
        {
          name: '预警预演',
          bg: 'tab_bottom_right',
          actBg: 'tab_bottom_right_active',
          isActive: false,
          viewCode: 'JK001',
          changeView: false,
        },
      ],
      selectedTab: 0,
    };
  },
  mounted() {
    this.$bus.$on('globalTabIndex', (data) => {
      this.selectedTab = data;
    });
  },
  methods: {
    activeTab(index) {
      // 先清除其他高亮

      setTimeout(() => {
        this.$Model.i3dInit();
      }, 300);
      setTimeout(() => {
        this.$Model.i3dSinkOff();
        console.log('offSink :>> ');
      }, 1000);

      const curTabName = this.tabs[index].name;
      const curChangeView = this.tabs[index].changeView;
      this.$bus.$emit('globalTab', curTabName);
      this.selectedTab = index;
      if (index == 1) {
        // 如果是底部点击的故障总览，则不需要显示右边栏
        this.$Storage.remove('warmFromIndex'); //由于组件还未渲染，所以要存一份在storage里面

        this.$bus.$emit('warmFromIndex', false);
        setTimeout(() => {
          this.$Model.i3dSinkOpen();
        }, 1200);
      }
      if (index == 2) {
        // 智能巡检
        setTimeout(() => {
          // 高亮巡检线路
          this.$Model.i3dHighLight('07', 'T3', '1');
        }, 1200);
      }
      if (index == 3) {
        setTimeout(() => {
          // 预演
          this.$Model.i3dCheckView('09');
        }, 1500);
      }
      if (curChangeView) {
        setTimeout(() => {
          this.$Model.i3dChangeViewByCode(this.tabs[index].viewCode);
        }, 1500);
      }
    },
    isSelected(index) {
      return index === this.selectedTab;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.side_content {
  width: 900px;
  height: 58px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 32px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  .side_item {
    width: 222px;
    height: 58px;
    line-height: 58px;
    color: rgba(203, 221, 255, 1);
    font-size: 22px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    &:first-child {
      .tab_title {
        padding-left: 20px;
      }
    }
    &:last-child {
      .tab_title {
        padding-right: 20px;
      }
    }
    .tab_title {
      position: absolute;
      top: 0;
      display: flex;
      align-items: center;
      .title_icon {
        width: 30px;
        height: 30px;
        img {
          display: block;
        }
      }
      .title_name {
        padding-left: 4px;
      }
    }

    &.active {
      color: rgba(239, 245, 255, 1);
    }
  }
}
</style>
